import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import cn from 'classnames';

import css from 'styles/components/productdetail/outOfStockPopoverWrapper.scss';
export const OutOfStockPopover = loadable(() => import('components/productdetail/OutOfStockPopover'));

class OutOfStockPopoverWrapper extends Component {
  state = {
    visible: null
  };

  componentDidUpdate(prevProps) {
    const { stock, onShow } = this.props;
    if (stock !== prevProps.stock) {
      this.setState({ visible: null });
    }
    if (!stock && prevProps.stock && this.state.visible === null) {
      onShow();
    }
  }

  onCloseClick = () => {
    this.setState({ visible: false });
  };

  render() {
    const { visible } = this.state;
    const { stock } = this.props;
    // Set initial visibility based on props (product is out of stock)
    // Subsequently, it should respect local state visibility when close button is clicked
    const isVisible = visible !== null ? visible : !stock;
    return (
      <div className={cn(css.oosPopoverWrapper, { [css.slideIn]: isVisible })}>
        {isVisible && <OutOfStockPopover {...this.props} onCloseClick={this.onCloseClick}/>}
      </div>
    );
  }
}

OutOfStockPopoverWrapper.propTypes = {
  brandId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  brandName: PropTypes.string.isRequired,
  onBrandNotifySubmit: PropTypes.func.isRequired,
  recos : PropTypes.object,
  stock: PropTypes.object,
  isSubmitted: PropTypes.bool
};

export default OutOfStockPopoverWrapper;
